var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relevant"},[(_vm.detialInfo.itemQuestion)?_c('div',{staticClass:"wrapper"},[_c('ArticleView',{attrs:{"content":_vm.detialInfo.itemQuestion}})],1):_c('van-empty',{attrs:{"description":"数据为空"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }